import Parse from 'parse/dist/parse.min.js';

const IMAGE_ENDPOINT = 'https://torlanco-getimageendpoint.web.val.run/?prompt=';

const categoryPrompts = {
  'Anti-Stress, Sleep and Mental Health': 'modern wellness pharmacy with calming blue lighting, premium supplements for mental health displayed on elegant glass shelves, serene atmosphere, professional healthcare environment, photorealistic, 4k',
  
  'Sexual Health': 'sophisticated medical wellness center with natural light, premium sexual health supplements displayed on minimalist shelves, professional clinical setting, warm tones, clean modern design, photorealistic, 4k',
  
  'Sports and Energy': 'high-end sports nutrition display in modern fitness clinic, premium performance supplements arranged on sleek shelves, bright professional lighting, athletic aesthetic, clean contemporary design, photorealistic, 4k',
  
  'Dermatology, SKIN, Esthetics': 'luxury dermatology clinic interior with premium skincare products, elegant display with soft lighting, medical-grade environment, sophisticated aesthetic, marble counters, photorealistic, 4k',
  
  'Gastro Intestinal Health and Weight Loss': 'contemporary nutrition clinic with premium digestive health supplements, elegant display with soft lighting, professional medical environment, clean minimalist design, wellness atmosphere, photorealistic, 4k',
  
  'Cardio, Heart, Circulatory': 'modern cardiology clinic with heart health supplements elegantly displayed, professional medical environment with soft lighting, premium healthcare products on glass shelves, clean clinical aesthetic, photorealistic, 4k',
  
  'Anti Inflammatory and Antioxidant': 'premium wellness center with anti-inflammatory supplements displayed on elegant shelves, soft professional lighting, clean medical environment, luxury healthcare aesthetic, photorealistic, 4k',
  
  'Immunity': 'contemporary immunology clinic with premium immune support supplements, elegant glass display cases, professional medical lighting, sophisticated healthcare environment, clean modern design, photorealistic, 4k',
  
  'default': 'luxury healthcare pharmacy with premium supplements elegantly displayed, professional medical environment, soft lighting, clean contemporary design, photorealistic, 4k'
};

const specialtyPrompts = {
  'Cardiología': 'modern cardiology clinic with heart health supplements elegantly displayed, professional medical environment, premium healthcare products, clean clinical aesthetic, photorealistic, 4k',
  'Dermatología': 'luxury dermatology clinic with premium skincare products, elegant display with soft lighting, sophisticated aesthetic, marble counters, photorealistic, 4k',
  'Gastroenterología': 'contemporary gastroenterology clinic with digestive health supplements, elegant display, professional medical environment, clean design, photorealistic, 4k',
  'Neurología': 'advanced neurology clinic with brain health supplements elegantly displayed, professional medical environment, sophisticated healthcare aesthetic, photorealistic, 4k',
  'Oftalmología': 'modern ophthalmology clinic with eye health supplements displayed on elegant shelves, professional lighting, clean clinical environment, photorealistic, 4k',
  'Ortopedia': 'contemporary orthopedic clinic with joint health supplements, professional medical environment, clean modern design, photorealistic, 4k',
  'Pediatría': 'warm pediatric clinic with children\'s health supplements, friendly professional environment, bright colors, clean modern design, photorealistic, 4k',
  'Psiquiatría': 'calming psychiatry clinic with mental health supplements displayed elegantly, serene atmosphere, professional environment, photorealistic, 4k',
  'Urología': 'professional urology clinic with urinary health supplements displayed on modern shelves, clean medical environment, photorealistic, 4k',
  'default': 'modern medical specialty clinic with premium health supplements elegantly displayed, professional environment, clean design, photorealistic, 4k'
};

const categoryImages = {
  'Anti-Stress, Sleep and Mental Health': 'https://images.unsplash.com/photo-1600267204091-5c1ab8b10c02?q=80&w=2070&auto=format&fit=crop',
  'Sexual Health': 'https://images.unsplash.com/photo-1628771065518-0d82f1938462?q=80&w=2070&auto=format&fit=crop',
  'Sports and Energy': 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?q=80&w=2070&auto=format&fit=crop',
  'Dermatology, SKIN, Esthetics': 'https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?q=80&w=2035&auto=format&fit=crop',
  'Gastro Intestinal Health and Weight Loss': 'https://images.unsplash.com/photo-1505576399279-565b52d4ac71?q=80&w=2070&auto=format&fit=crop',
  'Cardio, Heart, Circulatory': 'https://images.unsplash.com/photo-1628771065518-0d82f1938462?q=80&w=2070&auto=format&fit=crop',
  'Anti Inflammatory and Antioxidant': 'https://images.unsplash.com/photo-1563453392212-326f5e854473?q=80&w=2070&auto=format&fit=crop',
  'Immunity': 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?q=80&w=2080&auto=format&fit=crop',
  'default': 'https://images.unsplash.com/photo-1576602976047-174e57a47881?q=80&w=2069&auto=format&fit=crop'
};

const getCategoryImage = (name) => {
  // Usar imagen predefinida si existe, de lo contrario usar la imagen por defecto
  return categoryImages[name] || categoryImages.default;
};

const getSpecialtyImage = (name) => {
  const prompt = specialtyPrompts[name] || specialtyPrompts.default;
  return `${IMAGE_ENDPOINT}${encodeURIComponent(prompt)}`;
};

const getProductImage = (productName, categoryName) => {
  const prompt = `professional product photo of ${productName} for ${categoryName} category, clean medical supplement bottle, professional lighting, white background, 4k`;
  return `${IMAGE_ENDPOINT}${encodeURIComponent(prompt)}`;
};

// Helper function to process image data
const processImage = async (imageData) => {
  if (!imageData) return null;

  try {
    // If imageData is a File object, upload it
    if (imageData instanceof File) {
      const parseFile = new Parse.File(imageData.name, imageData);
      await parseFile.save();
      return parseFile;
    }
    
    // If imageData is a URL string, return it as is
    if (typeof imageData === 'string') {
      return imageData;
    }

    // If imageData is an object with url and prompt properties
    if (imageData.url) {
      return imageData.url;
    }

    return null;
  } catch (error) {
    console.error('Error processing image:', error);
    throw error;
  }
};

// Función auxiliar para manejar errores de red
const handleNetworkError = (error) => {
  console.error('Error de red:', error);
  
  // Verificar si es un error de red (502, 503, etc.)
  if (error.message && (error.message.includes('502') || 
      error.message.includes('Bad Gateway') ||
      error.message.includes('503') ||
      error.message.includes('Service Unavailable'))) {
    throw new Error('El servidor no está disponible en este momento. Por favor, intenta más tarde.');
  }
  
  // Si es otro tipo de error, simplemente lo propagamos
  throw error;
};

// Función para procesar imagen
const processAndSaveImage = async (imageData, productName) => {
  try {
    let parseFile = null;
    const fileName = `${productName.toLowerCase().replace(/\s+/g, '-')}.jpg`;

    if (imageData.type === 'generated') {
      // Para imágenes generadas, descargamos y guardamos
      parseFile = await urlToFile(imageData.url, fileName);
    } else if (imageData.type === 'uploaded' && imageData.file) {
      // Para imágenes subidas, convertimos a Parse.File
      const base64 = await blobToBase64(imageData.file);
      parseFile = new Parse.File(fileName, { base64: base64 });
    }

    if (parseFile) {
      try {
        await parseFile.save();
        return {
          file: parseFile,
          url: parseFile.url(),
          type: imageData.type,
          prompt: imageData.prompt
        };
      } catch (error) {
        console.warn('No se pudo guardar el archivo, usando URL directa:', error);
        return {
          url: imageData.url,
          type: imageData.type,
          prompt: imageData.prompt
        };
      }
    }

    return {
      url: imageData.url,
      type: imageData.type,
      prompt: imageData.prompt
    };
  } catch (error) {
    console.error('Error processing image:', error);
    return null;
  }
};

// Función para descargar imagen y convertir a Parse.File
const downloadAndCreateFile = async (url, fileName) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Parse.File(fileName, blob);
  } catch (error) {
    console.error('Error downloading image:', error);
    return null;
  }
};

// Función para convertir Blob a Parse.File
const createParseFile = async (file, fileName) => {
  try {
    if (file instanceof Blob) {
      return new Parse.File(fileName, file);
    }
    return null;
  } catch (error) {
    console.error('Error creating Parse File:', error);
    return null;
  }
};

// Función para convertir URL a File
const urlToFile = async (url, fileName) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const parseFile = new Parse.File(fileName, blob);
    try {
      await parseFile.save();
      return parseFile;
    } catch (saveError) {
      console.warn('Error saving file:', saveError);
      return null;
    }
  } catch (error) {
    console.error('Error converting URL to File:', error);
    return null;
  }
};

// Función auxiliar para convertir Blob a Base64
const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(',')[1];
      resolve(base64String);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const getCategories = async () => {
  console.log('Obteniendo categorías...');
  const query = new Parse.Query('HealthCategory');
  query.ascending('order');
  query.equalTo('status', 'active'); // Solo categorías activas
  
  try {
    console.log('Ejecutando query de categorías...');
    const results = await query.find();
    console.log('Resultados de categorías:', results);
    
    const mappedResults = results.map(category => {
      const name = category.get('name');
      
      // Forzar la generación de una nueva imagen usando Torlanco
      const image = getCategoryImage(name);
      
      const mappedCategory = {
        id: category.id,
        name: name,
        description: category.get('description'),
        order: category.get('order'),
        image: image,
        status: category.get('status')
      };
      
      console.log('Categoría mapeada:', mappedCategory);
      return mappedCategory;
    });
    
    console.log('Todas las categorías mapeadas:', mappedResults);
    return mappedResults;
  } catch (error) {
    console.error('Error al obtener categorías:', error);
    throw error;
  }
};

export const getProducts = async (categoryId = null, includeInactive = true) => {
  try {
    const Product = Parse.Object.extend('Product');
    const query = new Parse.Query(Product);
    query.include('category');
    query.include('medicalSpecialtiesRel');
    query.limit(1000);
    
    // Solo filtramos por estado si no queremos incluir inactivos
    if (!includeInactive) {
      query.equalTo('status', 'active'); // Solo productos activos
    }
    
    if (categoryId) {
      const categoryPointer = {
        __type: 'Pointer',
        className: 'HealthCategory',
        objectId: categoryId
      };
      query.equalTo('category', categoryPointer);
    }
    
    query.ascending('name');
    
    const results = await query.find();
    return results.map(product => {
      const category = product.get('category');
      let image = product.get('image');
      
      // Si no hay imagen, generamos una nueva usando el endpoint
      if (!image) {
        image = getProductImage(product.get('name'), category ? category.get('name') : null);
      }
      
      return {
        id: product.id,
        name: product.get('name'),
        description: product.get('description'),
        category: category ? {
          id: category.id,
          name: category.get('name')
        } : null,
        image: image,
        price: product.get('price'),
        status: product.get('status'),
        presentation: product.get('presentation'),
        content: product.get('content'),
        usage: product.get('usage'),
        ingredients: product.get('ingredients'),
        benefits: product.get('benefits') || [],
        featured: product.get('featured') || false,
        isCustomizable: product.get('isCustomizable') || false,
        medicalSpecialties: product.get('medicalSpecialtiesRel') || []
      };
    });
  } catch (error) {
    console.error('Error al obtener productos:', error);
    throw error;
  }
};

export const getProductsByCategory = async (categoryId, includeVariants = false) => {
  try {
    console.log('Obteniendo productos para la categoría con ID:', categoryId);
    
    // Si es una categoría de demostración, devolver productos de demo
    if (categoryId.startsWith('demo-category-')) {
      console.log('ID de categoría de demostración detectado.');
      return demoProducts;
    }
    
    // Buscar la categoría real
    const categoryQuery = new Parse.Query('HealthCategory');
    const category = await categoryQuery.get(categoryId);
    const categoryName = category.get('name');
    console.log('Categoría encontrada:', categoryName);
    
    // Buscar productos para esta categoría
    const query = new Parse.Query('Product');
    query.equalTo('healthCategory', category);
    query.include('medicalSpecialtiesRel');
    query.limit(1000); // Aumentar límite para evitar paginación
    
    // Crear una consulta alternativa para productos que usan el campo 'category' (string)
    // en lugar de 'healthCategory' (puntero)
    const categoryNameQuery = new Parse.Query('Product');
    categoryNameQuery.equalTo('category', categoryName);
    
    // Crear una consulta para productos que usan el campo 'healthCategories' (array de punteros)
    const healthCategoriesQuery = new Parse.Query('Product');
    healthCategoriesQuery.equalTo('healthCategories', category);
    
    // Crear consultas adicionales para variaciones en singular/plural
    const variations = [];
    
    // Variación 1: Si termina en 's', probar sin la 's'
    if (categoryName.endsWith('s')) {
      const singularName = categoryName.slice(0, -1);
      const singularQuery = new Parse.Query('Product');
      singularQuery.equalTo('category', singularName);
      variations.push(singularQuery);
      console.log(`Probando variación singular: ${singularName}`);
    } 
    // Variación 2: Si no termina en 's', probar añadiendo 's'
    else {
      const pluralName = `${categoryName}s`;
      const pluralQuery = new Parse.Query('Product');
      pluralQuery.equalTo('category', pluralName);
      variations.push(pluralQuery);
      console.log(`Probando variación plural: ${pluralName}`);
    }
    
    // Variación 3: Probar con la primera letra en mayúscula
    const capitalizedName = categoryName.charAt(0).toUpperCase() + categoryName.slice(1);
    if (capitalizedName !== categoryName) {
      const capitalizedQuery = new Parse.Query('Product');
      capitalizedQuery.equalTo('category', capitalizedName);
      variations.push(capitalizedQuery);
      console.log(`Probando variación capitalizada: ${capitalizedName}`);
    }
    
    // Combinar todas las consultas con OR
    let mainQuery = Parse.Query.or(query, categoryNameQuery, healthCategoriesQuery, ...variations);
    
    // Agregar un log para depuración
    console.log(`Buscando productos con: healthCategory=${categoryId}, category=${categoryName} y healthCategories=pointer`);
    
    const results = await mainQuery.find();
    
    console.log(`Búsqueda completa. Resultados encontrados: ${results.length}`);
    if (results.length === 0) {
      console.log(`No se encontraron productos para la categoría ${categoryName} (ID: ${categoryId})`);
      console.log(`Intentando búsqueda alternativa...`);
      
      // Intentar búsqueda sin filtros para verificar que hay productos
      const allProductsQuery = new Parse.Query('Product');
      allProductsQuery.limit(5); // Solo obtener 5 para prueba
      const testResults = await allProductsQuery.find();
      console.log(`Prueba de conexión: se encontraron ${testResults.length} productos en total (muestra de 5)`);
      
      if (testResults.length > 0) {
        // Mostrar los valores de categoría en algunos productos para depuración
        console.log('Ejemplos de valores de categoría en productos:');
        testResults.forEach(product => {
          const hCat = product.get('healthCategory');
          const strCat = product.get('category');
          console.log(`- Producto: ${product.get('name')}, healthCategory: ${hCat ? (hCat.id || 'objeto sin id') : 'null'}, category: ${strCat || 'null'}`);
        });
      }
    }
    
    if (results.length > 0) {
      console.log('Productos encontrados:', results.length);
      
      // Mapear los resultados a un formato más manejable
      let formattedProducts = results.map(product => {
        const category = product.get('healthCategory');
        let image = product.get('image');
        
        // Si no hay imagen, generamos una nueva usando el endpoint
        if (!image) {
          image = getProductImage(product.get('name'), category ? category.get('name') : null);
        }
        
        return {
          id: product.id,
          name: product.get('name'),
          description: product.get('description'),
          categoryId: category ? category.id : null,
          categoryName: category ? category.get('name') : null,
          image: image,
          presentation: product.get('presentation'),
          formats: product.get('formats'),
          countPerBottle: product.get('countPerBottle'),
          medicalSpecialties: product.get('medicalSpecialtiesRel') || [],
          moq: product.get('moq') || 200,
          pricing: product.get('pricing') || {},
          isCustomizable: product.get('isCustomizable') || false,
          isDemo: false
        };
      });
      
      return formattedProducts;
    }
    
    // Si no hay productos, devolver un array vacío
    console.log('No se encontraron productos reales para esta categoría.');
    return [];
  } catch (error) {
    console.error('Error al obtener productos por categoría:', error);
    return handleNetworkError(error);
  }
};

export const getProduct = async (productId) => {
  try {
    console.log('Obteniendo producto con ID:', productId);
    
    // Verificar si es un ID de producto de demostración
    if (productId.startsWith('demo-product-')) {
      console.log('ID de producto de demostración detectado. Devolviendo null.');
      return null;
    }
    
    // Buscar el producto real
    const query = new Parse.Query('Product');
    query.include('healthCategory');
    query.include('medicalSpecialtiesRel');
    
    const product = await query.get(productId);
    console.log('Producto encontrado:', product.get('name'));
    
    const category = product.get('healthCategory');
    const categoryName = product.get('categoryName') || (category ? category.get('name') : null);
    const productName = product.get('name') || 'Producto sin nombre';
    const description = product.get('description') || '';
    const moq = product.get('moq') || 200;
    
    // Normalizar especialidades médicas
    let normalizedSpecialties = [];
    const specialtiesRel = product.get('medicalSpecialtiesRel');
    const specialtiesArray = product.get('medicalSpecialties');
    
    if (specialtiesRel && specialtiesRel.length > 0) {
      normalizedSpecialties = specialtiesRel.map(specialty => ({
        id: specialty.id,
        name: specialty.get('name')
      }));
    } else if (specialtiesArray && specialtiesArray.length > 0) {
      normalizedSpecialties = specialtiesArray.map(name => ({
        id: null,
        name: name
      }));
    }
    
    // Procesamiento de imagen principal
    let mainImage = { url: null };
    const productImage = product.get('image');
    
    if (productImage && productImage.url) {
      try {
        const imageUrl = productImage.url();
        mainImage = {
          url: imageUrl,
        };
        console.log('URL de imagen principal desde Parse:', imageUrl);
      } catch (e) {
        console.log('Error al obtener URL de imagen principal:', e);
        if (typeof productImage === 'object' && productImage.url) {
          mainImage = {
            url: productImage.url
          };
        }
      }
    } else if (typeof productImage === 'string') {
      mainImage = {
        url: productImage
      };
      console.log('URL de imagen principal como string:', productImage);
    } else if (productImage && typeof productImage === 'object') {
      // Intenta extraer la URL directamente si es un objeto
      mainImage = {
        url: productImage.url || null
      };
      console.log('URL de imagen principal desde objeto:', mainImage.url);
    } else {
      // Usar una imagen local como fallback
      const filename = product.id.toLowerCase().replace(/[^a-z0-9]/g, '-');
      const fallbackUrl = `images/products/${filename}.jpg`;
      
      // Verificar si existe en la carpeta public
      mainImage = {
        url: fallbackUrl
      };
      console.log('Usando URL de fallback para imagen principal:', fallbackUrl);
    }
    
    // Formatear presentación y formatos
    const presentation = product.get('presentation') || null;
    const formats = product.get('formats') || [];
    const countPerBottle = product.get('countPerBottle') || [];
    
    // Devolver el producto formateado
    return {
      id: product.id,
      name: productName,
      code: product.get('code') || '',
      description: description,
      categoryId: category ? category.id : null,
      categoryName: category ? category.get('name') : categoryName,
      image: mainImage,
      presentation: presentation,
      formats: formats,
      countPerBottle: countPerBottle,
      ingredients: product.get('ingredients') || '',
      benefits: product.get('benefits') || [],
      medicalSpecialties: normalizedSpecialties,
      moq: moq,
      pricing: product.get('pricing') || {},
      isCustomizable: product.get('isCustomizable') || false,
      isDemo: false
    };
  } catch (error) {
    console.error('Error al obtener producto:', error);
    
    // Verificar si es un error de red (502, 503, etc.)
    if (error.message && (error.message.includes('502') || 
        error.message.includes('Bad Gateway') ||
        error.message.includes('503') ||
        error.message.includes('Service Unavailable'))) {
      console.warn('Error de servidor detectado, manejando graciosamente');
      throw new Error('El servidor no está disponible en este momento. Por favor, intenta más tarde.');
    }
    
    // Si el producto no existe o hubo otro tipo de error, devolvemos null
    return null;
  }
};

/**
 * Alias para getProduct, para mantener coherencia de nombres de métodos
 * @param {string} productId - ID del producto a buscar
 * @returns {Object} - Datos del producto
 */
export const getProductById = async (productId) => {
  return getProduct(productId);
};

/**
 * Obtiene todos los productos disponibles
 * @returns {Object} - Objeto con arreglo de productos y total
 */
export const getAllProducts = async () => {
  console.log('Iniciando getAllProducts');
  try {
    // Primero, cargar todas las categorías para tener un mapa de ID a nombre
    const categoryMap = {};
    try {
      const categoryQuery = new Parse.Query('HealthCategory');
      const categories = await categoryQuery.find();
      console.log('Categorías cargadas:', categories.length);
      
      // Crear un mapa de ID a nombre de categoría
      categories.forEach(category => {
        categoryMap[category.id] = category.get('name');
      });
      
      console.log('Mapa de categorías creado:', Object.keys(categoryMap).length);
    } catch (err) {
      console.error('Error al cargar categorías:', err);
    }
    
    const query = new Parse.Query('Product');
    query.include('healthCategory'); // Include the healthCategory pointer
    query.include('category'); // Try including category field if it exists
    query.include('medicalSpecialtiesRel'); // Include medical specialties
    query.limit(100); // Límite razonable para no sobrecargar
    
    console.log('Ejecutando query para obtener productos');

    const results = await query.find();
    
    // Generar URLs de imágenes de demostración basadas en el nombre del producto
    const generateDemoImageUrl = (productName) => {
      // Normalizar el nombre del producto para usarlo en la URL
      const normalizedName = productName
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
      
      // Generar un color basado en el nombre del producto
      let hash = 0;
      for (let i = 0; i < productName.length; i++) {
        hash = productName.charCodeAt(i) + ((hash << 5) - hash);
      }
      
      // Convertir el hash a un color hexadecimal para el fondo
      let r = (hash & 0xFF0000) >> 16;
      let g = (hash & 0x00FF00) >> 8;
      let b = hash & 0x0000FF;
      
      // Asegurar que los colores sean pastel (claros)
      r = Math.min(255, Math.max(150, r));
      g = Math.min(255, Math.max(150, g));
      b = Math.min(255, Math.max(150, b));
      
      // Convertir a formato hexadecimal
      const bgColor = ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0');
      const textColor = '333333';
      
      // Crear una URL de placeholder con el nombre del producto
      return `https://placehold.co/600x600/${bgColor}/${textColor}?text=${encodeURIComponent(productName)}`;
    };
    
    const products = results.map(product => {
      const category = product.get('healthCategory');
      const productName = product.get('name') || 'Producto sin nombre';
      
      // Manejar la imagen de forma segura
      let imageObj = null;
      try {
        const image = product.get('image');
        console.log(`Procesando imagen para producto ${product.id}:`, image);
        
        if (image) {
          // Si es un objeto Parse.File
          if (image instanceof Parse.File) {
            imageObj = image.url();
            console.log(`Imagen Parse.File encontrada para ${product.id}:`, imageObj);
          } 
          // Si es un objeto con método url
          else if (typeof image.url === 'function') {
            imageObj = image.url();
            console.log(`Imagen con método url() encontrada para ${product.id}:`, imageObj);
          }
          // Si es un objeto con propiedad url
          else if (image.url) {
            imageObj = image.url;
            console.log(`Imagen con propiedad url encontrada para ${product.id}:`, imageObj);
          }
          // Si es un string directo
          else if (typeof image === 'string') {
            imageObj = image;
            console.log(`Imagen como string encontrada para ${product.id}:`, imageObj);
          }
        }
        
        // Verificar si la imagen es una ruta a un archivo local
        if (imageObj && typeof imageObj === 'string' && (imageObj.startsWith('/images/') || imageObj.startsWith('images/'))) {
          // Mantener la ruta relativa tal como está
          console.log(`Imagen con ruta relativa para ${product.id}:`, imageObj);
        }
        // Si no se encontró ninguna imagen, generar una imagen de demostración
        else if (!imageObj) {
          imageObj = generateDemoImageUrl(productName);
          console.log(`Generando imagen de demostración para ${productName}:`, imageObj);
        }
      } catch (err) {
        console.warn(`Error al procesar la imagen del producto ${product.id}:`, err);
        // En caso de error, también generar una imagen de demostración
        imageObj = generateDemoImageUrl(productName);
      }
      
      // Process medical specialties if available
      const medicalSpecialtiesRel = product.get('medicalSpecialtiesRel') || [];
      const medicalSpecialties = medicalSpecialtiesRel.map(specialty => ({
        id: specialty.id,
        name: specialty.get('name')
      }));
      
      // If no specialties are found, assign default test specialties for development
      const testSpecialties = [
        { id: 'psicologia', name: 'Psicología' },
        { id: 'cardiologia', name: 'Cardiología' },
        { id: 'pediatria', name: 'Pediatría' },
        { id: 'alergista', name: 'Alergista' },
        { id: 'dermatologia', name: 'Dermatología' }
      ];
      
      // If no specialties from database, assign a random test specialty
      const assignedSpecialties = medicalSpecialties.length > 0 ? 
        medicalSpecialties : 
        [testSpecialties[Math.floor(Math.random() * testSpecialties.length)]];
      
      // Recopilar todas las categorías del producto
      let allCategories = [];
      let categoryName = 'Sin categoría';
      let categoryId = null;
      let categorySource = null;
      
      // 1. Intentar obtener de healthCategory (puntero a HealthCategory)
      const healthCategory = product.get('healthCategory');
      if (healthCategory) {
        try {
          const name = healthCategory.get('name');
          const id = healthCategory.id;
          allCategories.push({
            name,
            id,
            source: 'healthCategory (puntero)'
          });
          categoryName = name;
          categoryId = id;
          categorySource = 'healthCategory (puntero)';
          console.log(`Producto ${product.id}: Categoría encontrada en healthCategory - ${name} (${id})`);
        } catch (err) {
          console.error(`Error al obtener nombre de categoría para producto ${product.id}:`, err);
          
          // Si falla, intentar usar el mapa de categorías
          if (healthCategory.id && categoryMap[healthCategory.id]) {
            const name = categoryMap[healthCategory.id];
            const id = healthCategory.id;
            allCategories.push({
              name,
              id,
              source: 'healthCategory (mapa de categorías)'
            });
            categoryName = name;
            categoryId = id;
            categorySource = 'healthCategory (mapa de categorías)';
            console.log(`Producto ${product.id}: Categoría encontrada en mapa - ${name} (${id})`);
          }
        }
      }
      
      // 2. Intentar obtener de category (campo de texto)
      const categoryString = product.get('category');
      if (categoryString && typeof categoryString === 'string') {
        allCategories.push({
          name: categoryString,
          id: null,
          source: 'category (texto)'
        });
        if (categoryName === 'Sin categoría') {
          categoryName = categoryString;
          categorySource = 'category (texto)';
        }
        console.log(`Producto ${product.id}: Categoría encontrada en category (string) - ${categoryString}`);
      }
      
      // 3. Intentar obtener de category (puntero a otra tabla)
      const categoryObj = product.get('category');
      if (categoryObj && typeof categoryObj.get === 'function') {
        try {
          const name = categoryObj.get('name');
          const id = categoryObj.id;
          allCategories.push({
            name,
            id,
            source: 'category (puntero)'
          });
          if (categoryName === 'Sin categoría') {
            categoryName = name;
            categoryId = id;
            categorySource = 'category (puntero)';
          }
          console.log(`Producto ${product.id}: Categoría encontrada en category (pointer) - ${name} (${id})`);
        } catch (err) {
          console.error(`Error al obtener nombre de category (puntero) para producto ${product.id}:`, err);
        }
      }
      
      // 4. Intentar obtener de healthCategories (array de punteros)
      const healthCategories = product.get('healthCategories');
      if (healthCategories && healthCategories.length > 0) {
        console.log(`Producto ${product.id}: Encontradas ${healthCategories.length} categorías en healthCategories`);
        
        // Procesar cada categoría en el array
        for (let i = 0; i < healthCategories.length; i++) {
          const category = healthCategories[i];
          try {
            // Si es un objeto Parse
            if (category && typeof category.get === 'function') {
              try {
                const name = category.get('name');
                const id = category.id;
                allCategories.push({
                  name,
                  id,
                  source: `healthCategories[${i}] (puntero)`
                });
                if (categoryName === 'Sin categoría') {
                  categoryName = name;
                  categoryId = id;
                  categorySource = `healthCategories[${i}] (puntero)`;
                }
                console.log(`Producto ${product.id}: Categoría encontrada en healthCategories[${i}] - ${name} (${id})`);
              } catch (nameErr) {
                console.error(`Error al obtener nombre de healthCategories[${i}] para producto ${product.id}:`, nameErr);
                
                // Intentar usar el mapa de categorías
                if (category.id && categoryMap[category.id]) {
                  const name = categoryMap[category.id];
                  const id = category.id;
                  allCategories.push({
                    name,
                    id,
                    source: `healthCategories[${i}] (mapa de categorías)`
                  });
                  if (categoryName === 'Sin categoría') {
                    categoryName = name;
                    categoryId = id;
                    categorySource = `healthCategories[${i}] (mapa de categorías)`;
                  }
                  console.log(`Producto ${product.id}: Categoría encontrada en mapa - ${name} (${id})`);
                }
              }
            } 
            // Si es una cadena de texto
            else if (typeof category === 'string') {
              allCategories.push({
                name: category,
                id: null,
                source: `healthCategories[${i}] (texto)`
              });
              if (categoryName === 'Sin categoría') {
                categoryName = category;
                categorySource = `healthCategories[${i}] (texto)`;
              }
              console.log(`Producto ${product.id}: Categoría encontrada en healthCategories[${i}] (string) - ${category}`);
            } 
            // Si es un objeto con objectId
            else if (category && category.objectId) {
              const id = category.objectId;
              
              // Intentar usar el mapa de categorías
              if (categoryMap[id]) {
                const name = categoryMap[id];
                allCategories.push({
                  name,
                  id,
                  source: `healthCategories[${i}] (mapa de categorías)`
                });
                if (categoryName === 'Sin categoría') {
                  categoryName = name;
                  categoryId = id;
                  categorySource = `healthCategories[${i}] (mapa de categorías)`;
                }
                console.log(`Producto ${product.id}: Categoría encontrada en mapa - ${name} (${id})`);
              } 
              // Si no está en el mapa, intentar obtener el nombre directamente del objeto
              else if (category.name) {
                allCategories.push({
                  name: category.name,
                  id,
                  source: `healthCategories[${i}] (nombre directo)`
                });
                if (categoryName === 'Sin categoría') {
                  categoryName = category.name;
                  categoryId = id;
                  categorySource = `healthCategories[${i}] (nombre directo)`;
                }
                console.log(`Producto ${product.id}: Nombre encontrado directamente en el objeto:`, category.name);
              }
            }
          } catch (err) {
            console.error(`Error al procesar healthCategories[${i}] para producto ${product.id}:`, err);
          }
        }
      }
      
      // Eliminar duplicados basados en el ID o nombre
      const uniqueCategories = [];
      const seenIds = new Set();
      const seenNames = new Set();
      
      allCategories.forEach(cat => {
        if (cat.id && !seenIds.has(cat.id)) {
          seenIds.add(cat.id);
          uniqueCategories.push(cat);
        } else if (!cat.id && cat.name && !seenNames.has(cat.name)) {
          seenNames.add(cat.name);
          uniqueCategories.push(cat);
        }
      });
      
      // Si no se encontró ninguna categoría, agregar una categoría por defecto
      if (uniqueCategories.length === 0) {
        uniqueCategories.push({
          name: 'Sin categoría',
          id: null,
          source: 'valor por defecto'
        });
      }
      
      // Si no se encontró categoría, registrar esto también
      if (categoryName === 'Sin categoría') {
        console.log(`Producto ${product.id}: No se encontró categoría en ningún campo`);
        // Mostrar todos los campos disponibles para depuración
        console.log(`Producto ${product.id} - Campos disponibles:`, Object.keys(product.attributes));
      }
      
      return {
        id: product.id,
        name: productName,
        description: product.get('description') || '',
        categoryId: categoryId,
        categoryName: categoryName,
        categorySource: categorySource,
        categories: uniqueCategories,
        image: imageObj,
        formats: product.get('formats') || [],
        countPerBottle: product.get('countPerBottle') || [],
        code: product.get('code') || '',
        isDemo: !product.get('image'),
        medicalSpecialties: assignedSpecialties
      };
    });

    console.log('Productos procesados correctamente:', products.length);
    return {
      products,
      total: products.length
    };
  } catch (error) {
    console.error('Error al obtener todos los productos:', error);
    
    // Retornar lista vacía en caso de error
    return {
      products: [],
      total: 0,
      error: error.message
    };
  }
};

/**
 * Obtiene una categoría específica por su ID
 * @param {string} categoryId - ID de la categoría a buscar
 * @returns {Object} - Datos de la categoría o null si no existe
 */
export const getCategory = async (categoryId) => {
  try {
    console.log(`Buscando categoría con ID: ${categoryId}`);
    
    const query = new Parse.Query('HealthCategory');
    query.equalTo('status', 'active'); // Solo categorías activas
    
    const category = await query.get(categoryId);
    
    if (!category) {
      console.log('Categoría no encontrada');
      return null;
    }
    
    console.log('Categoría encontrada:', category.get('name'));
    
    const name = category.get('name');
    let image = category.get('image');
    
    // Si no hay imagen, generamos una nueva usando el endpoint
    if (!image) {
      image = getCategoryImage(name);
    } else if (image.url) {
      image = {
        url: image.url()
      };
    }
    
    return {
      id: category.id,
      name: name,
      description: category.get('description'),
      order: category.get('order'),
      image: image,
      status: category.get('status')
    };
  } catch (error) {
    console.error('Error al obtener categoría:', error);
    
    // Verificar si es un error de red (502, 503, etc.)
    if (error.message && (error.message.includes('502') || 
        error.message.includes('Bad Gateway') ||
        error.message.includes('503') ||
        error.message.includes('Service Unavailable'))) {
      console.warn('Error de servidor detectado al obtener categoría, manejando graciosamente');
      throw new Error('El servidor no está disponible en este momento. Por favor, intenta más tarde.');
    }
    
    // Para otros tipos de error, devolvemos null
    return null;
  }
};

export const createProduct = async (productData) => {
  try {
    const Product = Parse.Object.extend('Product');
    const product = new Product();

    // Procesar imagen si existe
    const processedImage = productData.image ? 
      await processAndSaveImage(productData.image, productData.name) : null;

    // Crear un puntero a la categoría
    const categoryPointer = new Parse.Object('HealthCategory');
    categoryPointer.id = productData.category;

    // Establecer los campos básicos
    product.set('name', productData.name);
    product.set('code', productData.code);
    product.set('supplier', productData.supplier);
    product.set('ingredients', productData.ingredients);
    product.set('benefits', productData.benefits);
    product.set('formats', productData.formats);
    product.set('countPerBottle', productData.countPerBottle);
    product.set('moq', productData.moq || 0);
    product.set('status', 'active');

    // Procesar especialidades médicas
    if (productData.medicalSpecialtiesRel && productData.medicalSpecialtiesRel.length > 0) {
      const specialtyPointers = productData.medicalSpecialtiesRel.map(specialtyId => {
        const specialtyPointer = new Parse.Object('MedicalSpecialty');
        specialtyPointer.id = specialtyId;
        return specialtyPointer;
      });
      product.set('medicalSpecialtiesRel', specialtyPointers);
    }

    // Guardar información de la imagen
    if (processedImage) {
      if (processedImage.file) {
        product.set('imageFile', processedImage.file);
      }
      if (processedImage.url) {
        product.set('image', processedImage.url);
      }
      if (processedImage.prompt) {
        product.set('imagePrompt', processedImage.prompt);
      }
    }

    const result = await product.save();
    return {
      id: result.id,
      ...productData,
      image: processedImage
    };
  } catch (error) {
    console.error('Error creating product:', error);
    throw error;
  }
};

export const updateProduct = async (productId, productData) => {
  try {
    const Product = Parse.Object.extend('Product');
    const query = new Parse.Query(Product);
    const product = await query.get(productId);
    if (!product) {
      throw new Error('Producto no encontrado');
    }

    // Procesar imagen si existe
    const processedImage = productData.image ? 
      await processAndSaveImage(productData.image, productData.name) : null;

    // Actualizar puntero a la categoría si cambió
    if (productData.category) {
      const categoryPointer = new Parse.Object('HealthCategory');
      categoryPointer.id = productData.category;
      product.set('category', categoryPointer);
    }

    // Actualizar los campos básicos
    product.set('name', productData.name);
    product.set('code', productData.code);
    product.set('supplier', productData.supplier);
    product.set('ingredients', productData.ingredients);
    product.set('benefits', productData.benefits);
    product.set('formats', productData.formats);
    product.set('countPerBottle', productData.countPerBottle);
    product.set('moq', productData.moq || 0);

    // Actualizar especialidades médicas
    if (productData.medicalSpecialtiesRel && Array.isArray(productData.medicalSpecialtiesRel)) {
      const specialtyPointers = productData.medicalSpecialtiesRel.map(specialtyId => {
        const specialtyPointer = new Parse.Object('MedicalSpecialty');
        specialtyPointer.id = specialtyId;
        return specialtyPointer;
      });
      product.set('medicalSpecialtiesRel', specialtyPointers);
    }

    // Actualizar información de la imagen
    if (processedImage) {
      if (processedImage.file) {
        product.set('imageFile', processedImage.file);
      }
      if (processedImage.url) {
        product.set('image', processedImage.url);
      }
      if (processedImage.prompt) {
        product.set('imagePrompt', processedImage.prompt);
      }
    }

    const result = await product.save();
    return {
      id: result.id,
      ...productData,
      image: processedImage
    };
  } catch (error) {
    console.error('Error updating product:', error);
    throw error;
  }
};

export const createCategory = async (categoryData) => {
  try {
    const Category = Parse.Object.extend('HealthCategory');
    const category = new Category();

    // Procesar imagen si existe
    const processedImage = categoryData.image ? 
      await processAndSaveImage(categoryData.image, categoryData.name) : null;

    category.set('name', categoryData.name);
    category.set('description', categoryData.description);
    category.set('status', categoryData.status || 'active');
    category.set('order', categoryData.order || 0);

    // Guardar información de la imagen
    if (processedImage) {
      if (processedImage.file) {
        category.set('imageFile', processedImage.file);
      }
      if (processedImage.url) {
        category.set('image', processedImage.url);
      }
      if (processedImage.prompt) {
        category.set('imagePrompt', processedImage.prompt);
      }
    }

    const result = await category.save();
    return {
      id: result.id,
      ...categoryData
    };
  } catch (error) {
    console.error('Error creating category:', error);
    throw error;
  }
};

export const updateCategory = async (categoryId, categoryData) => {
  try {
    const Category = Parse.Object.extend('HealthCategory');
    const query = new Parse.Query(Category);
    const category = await query.get(categoryId);

    // Procesar imagen si existe
    const processedImage = categoryData.image ? 
      await processAndSaveImage(categoryData.image, categoryData.name) : null;

    category.set('name', categoryData.name);
    category.set('description', categoryData.description);
    category.set('status', categoryData.status || 'active');
    category.set('order', categoryData.order || category.get('order') || 0);

    // Actualizar información de la imagen
    if (processedImage) {
      if (processedImage.file) {
        category.set('imageFile', processedImage.file);
      }
      if (processedImage.url) {
        category.set('image', processedImage.url);
      }
      if (processedImage.prompt) {
        category.set('imagePrompt', processedImage.prompt);
      }
    }

    const result = await category.save();
    return {
      id: result.id,
      ...categoryData
    };
  } catch (error) {
    console.error('Error updating category:', error);
    throw error;
  }
};

export const deleteCategory = async (categoryId) => {
  try {
    const Category = Parse.Object.extend('HealthCategory');
    const query = new Parse.Query(Category);
    const category = await query.get(categoryId);
    await category.destroy();
  } catch (error) {
    console.error('Error deleting category:', error);
    throw error;
  }
};

export const deleteProduct = async (productId) => {
  try {
    const Product = Parse.Object.extend('Product');
    const query = new Parse.Query(Product);
    const product = await query.get(productId);
    await product.destroy();
  } catch (error) {
    console.error('Error deleting product:', error);
    throw error;
  }
};

export const getMedicalSpecialties = async () => {
  try {
    console.log('Obteniendo especialidades médicas...');
    const query = new Parse.Query('MedicalSpecialty');
    query.equalTo('status', 'active');
    query.ascending('name');
    const results = await query.find();
    
    const mappedResults = results.map(specialty => {
      const name = specialty.get('name');
      
      // Forzar la generación de una nueva imagen usando Torlanco
      const image = getSpecialtyImage(name);
      
      const mappedSpecialty = {
        id: specialty.id,
        name: name,
        description: specialty.get('description') || '',
        image: image,
        status: specialty.get('status') || 'active'
      };
      
      console.log('Especialidad médica mapeada:', mappedSpecialty);
      return mappedSpecialty;
    });
    
    console.log('Todas las especialidades médicas mapeadas:', mappedResults);
    return mappedResults;
  } catch (error) {
    console.error('Error al obtener especialidades médicas:', error);
    throw error;
  }
};

function generateDemoProductNames(categoryName) {
  // Crear nombres de productos basados en la categoría
  const prefixes = ['Ultra', 'Pro', 'Vita', 'Nutri', 'Med', 'Bio', 'Natural', 'Premium'];
  const suffixes = ['Plus', 'Max', 'Complex', 'Formula', 'Advanced', 'Elite', 'Essential'];
  
  // Extraer una palabra clave de la categoría
  let keyword = '';
  if (categoryName) {
    const words = categoryName.split(' ');
    // Elegir la palabra más larga o significativa (excepto palabras comunes)
    const commonWords = ['de', 'y', 'para', 'la', 'el', 'los', 'las', 'a'];
    const filteredWords = words.filter(word => !commonWords.includes(word.toLowerCase()) && word.length > 3);
    
    if (filteredWords.length > 0) {
      // Ordenar por longitud y tomar la más larga
      keyword = filteredWords.sort((a, b) => b.length - a.length)[0];
    } else if (words.length > 0) {
      // Si no hay palabras significativas, tomar cualquiera
      keyword = words[0];
    }
  }
  
  if (!keyword) {
    keyword = 'Health';
  }
  
  // Generar 4 nombres únicos
  const names = [];
  while (names.length < 4) {
    const prefix = prefixes[Math.floor(Math.random() * prefixes.length)];
    const suffix = suffixes[Math.floor(Math.random() * suffixes.length)];
    
    // Hay varias formas de combinar los elementos para crear nombres variados
    const nameOptions = [
      `${prefix} ${keyword}`,
      `${keyword} ${suffix}`,
      `${prefix} ${keyword} ${suffix}`,
      `${keyword}${prefix}`,
      `${prefix}-${keyword}`
    ];
    
    const newName = nameOptions[Math.floor(Math.random() * nameOptions.length)];
    
    // Asegurarse de que no haya duplicados
    if (!names.includes(newName)) {
      names.push(newName);
    }
  }
  
  return names;
}
